<template>
     <v-container fluid>
         <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Cambio Estado Masivo de Credito</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
         <!-- <v-card>
            
            <v-card-text>
                <v-row dense>
                    <v-col cols ="3">
                        <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Casos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                    <v-col cols ="3">
                        <v-autocomplete v-model="filtro.subEstadoId" :items="listSubEstados" autocomplete="disabled"
                            item-text="descripcion" item-value="id" label="Nuevo Estado de Credito" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col >
                        <v-alert color="info" dark dense>
                        <div>
                            Tener en Cuenta. El archivo debe tener formato Excel, con 1 columnas (Columnas/Encabezados): 
                        </div>
                        <div>
                        <v-radio-group v-model="filtro.esDocumento" column :mandatory="true">
                         <v-radio :value='false' label="Credito"></v-radio>
                        </v-radio-group>
                        </div>                                             
                        </v-alert>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-file-input  
                            v-model="archivoFiltroOperaciones"
                            placeholder="Seleccione el archivo Excel con los Casos"
                            label="Archivo Filtro"
                            prepend-icon="mdi-paperclip">
                        </v-file-input>
                    </v-col>
                    <v-col cols="2">
                        <v-btn @click="traerListaOperacionesDeExcel()">
                            Comprobar Archivo
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="archivoFiltroOperaciones != null">
                    <v-col>
                    <v-chip v-if="filtro.listaNumeroCreditos == ''" label color="warning">
                        Presione Comprobar Archivo para procesarlo
                    </v-chip>

                    
                    
                    <template v-else>
                        <div v-if="filtro.esDocumento" >
                            Hay {{filtro.listaNumeroCreditos.cantidad }} Documentos en el Archivo
                        </div>
                        <div v-else >
                            Hay {{filtro.listaNumeroCreditos.cantidad }} Créditos en el Archivo
                        </div>
                    </template>
                    </v-col>
                </v-row>
            
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="procesar">
                    Cambiar Estados&nbsp;                    
                </v-btn>
            </v-card-actions>
        </v-card> -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header v-slot="{  }">
                    <v-row>
                        <v-col>Asignacion de Cupo</v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row dense>
                        <v-col cols ="3">
                            <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                                item-text="nombre" item-value="id" label="Casos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col>
                            <v-file-input  
                                v-model="updateCreditoFile"
                                placeholder="Seleccione el archivo Excel"
                                label="Archivo Filtro"
                                prepend-icon="mdi-paperclip">
                            </v-file-input>
                        </v-col>
                        <v-col>
                            <v-btn @click="procesar2()">
                                Asignar Cupo
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="erroresProceso">
                        <ul id="example-2">
                            <li v-for="(error) in erroresProceso" >
                                {{ error }} 
                            </li>
                        </ul>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            loadingRespuestas: false,
            filtro: {empresaId: 1,  listaNumeroCreditos: '',subEstadoId:0, esDocumento : false},
            listEmpresas: [],
            listSubEstados: [],
            selectedCreditos: [],
            archivoFiltroOperaciones:[],
            updateCreditoFile:null,
            erroresProceso: null           
        }
    },
    async created() {
      this.loadEmpresas();
      this.loadSubEstados();
    
    
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
        return this.getActionFromLink(this.$route.path) 
        },
    },
    methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadSubEstados(){
      this.loading = true;
      try{
        var result = await http.get('tipossubestadocredito?estadosParaActivar=false&estadosActivos=true');

        this.listSubEstados = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async procesar() {
      this.loading = true;

        if(this.filtro.empresaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Empresa.');
            return;
        }
    
        if(this.filtro.subEstadoId === 0)
        {
            this.alertWarning('Por favor, especifique el Estado al cual se van a cambiar los creditos');
            return;
        }
      
      this.loading = true;
    
      try {
        var params = {};
        params.listaId = this.filtro.operacionesFiltro.id;
        params.empresaId = this.filtro.empresaId;
        params.nuevoSubEstadoId = this.filtro.subEstadoId;
        
        console.log(JSON.stringify( {parametros2 :  params} ))

        await http.post('creditos/cambiarestadomasivo', JSON.stringify( {parametros2 :  params} ) );

        await this.alertSuccess('Se ha modificado el estado de los créditos.')

      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
      
    },

    async traerListaOperacionesDeExcel(){

      if(!this.archivoFiltroOperaciones) return;
      if(!this.archivoFiltroOperaciones.name.includes('.xls'))
      {
        this.archivoFiltroOperaciones = [];
        this.alertWarning('Debe elegir un archivo Excel.');
        return;
      }

      this.loading = true;
      let formData = new FormData();  

      formData.append('archivo',this.archivoFiltroOperaciones);

      try{
        var listaOps = await http.post('archivosDebito/excelAFiltroOperaciones', formData);        
        this.filtro.operacionesFiltro =listaOps;
      } catch (error) {
          // Error
          this.alertError(error)
      }
      
      this.loading = false;

    },
    async procesar2(){
        if(this.filtro.empresaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Empresa.');
            return;
        }

        if(!this.updateCreditoFile || !this.updateCreditoFile.name.includes('.xls'))
        {
            this.updateCreditoFile = null;
            this.alertWarning('Debe elegir un archivo Excel.');
            return;
        }

        this.loading = true;
        
        let formData = new FormData();  
        formData.append('empresaId',this.filtro.empresaId);
        formData.append('excelFile',this.updateCreditoFile);        
        
        try {
            var res = await http.post('creditos/asignacioncupomasivo', formData);
            console.log(res)
            if(res.length > 0){
                this.alertWarning(`Hubo algunos errores durante el proceso.`);
                this.erroresProceso = res;
            }
            else{
                this.alertSuccess(`Los creditos se cambiaron con exito`);
            }
        } 
        catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },

},
  
}
</script>